import {Component, OnInit} from '@angular/core';
import {Timecard} from '../../../_models/timecard';
import {TimecardService} from '../../../_services/timecard.service';
import {OrganizationService} from '../../../_services/organization.service';
import {LoadingService} from '../../../_services/loading.service';
import {ModalController} from '@ionic/angular';
import {BaseTimecardWidgetComponent} from '../base-timecard-widget.component';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-flagged-timecards-widget',
    templateUrl: './flagged-timecards-widget.component.html',
    styleUrls: ['./flagged-timecards-widget.component.scss'],
})
export class FlaggedTimecardsWidgetComponent extends BaseTimecardWidgetComponent implements OnInit {

    constructor(
        timecardService: TimecardService,
        organizationService: OrganizationService,
        loadingService: LoadingService,
        modalController: ModalController,
        columnFormatterService: ColumnFormatterService
    ) {
        super(timecardService,
            organizationService,
            loadingService,
            modalController,
            columnFormatterService);
    }

    ngOnInit(): void {
    }

    refresh() {
        if (!!this.organization) {
            this.timecardService.flagged(this.widget.parentId, this.selectedPickupLocations)
                .subscribe((t: Timecard[]) => {
                    this.timecards = t;
                    this.loading = false;
                    this.error = false;
                    this.dataReady.emit();
                }, () => {
                    this.error = true;
                    this.loading = false;
                    this.timecards = null;
                });
        }
    }
}
